import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Control, Margin, Grid, GridRow, GridCol,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './CreateHandlerForm.module.sass';

interface DefineAttributesFormProps {
  onSubmit: (values: unknown) => void;
}
function DefineAttributesForm({
  onSubmit,
}: DefineAttributesFormProps): React.JSX.Element {
  const { t } = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm();

  return (
    <form
      data-testid="modal.defineAttributes"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid>
        <GridRow>
          <GridCol>
            <Margin display="block">
              <span className={st.Description}>
                {t('handlers:preset_scenario_4_description')}
              </span>
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('handlers:form.policy_name')}
              </div>
              <Control.Input
                {...register('description', {
                  maxLength: validate.maxLength(128),
                  required: validate.required(),
                })}
                errors={errors}
              />
            </Margin>
          </GridCol>
        </GridRow>
      </Grid>
      <Margin display="block">
        <Control.Button
          fullWidth
          type="submit"
        >
          {t('handlers:create')}
        </Control.Button>
      </Margin>
    </form>
  );
}

export default DefineAttributesForm;
